import { Attributes, Misc, Model, NeoModel, Rules, Validation, ValueObject } from '@singularsystems/neo-core';

@NeoModel
export default class UtilisationCriteria extends ValueObject {

    public issuerInvestmentId: number = 0;

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public balanceDate: Date | null = null;

    // Client only properties / methods

    public static getCriteriaObject(obj: Model.PartialPlainNonTrackedObject<UtilisationCriteria>) {
        // This seems pointless, but it required to convert the date to a non localised date.
        return UtilisationCriteria.mapFrom<UtilisationCriteria>(obj).toQueryObject();
    }

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Utilisation Criteria";
    }
}